module.exports = "/hwa/_next/static/images/skip-hire-6180b3874650336f2661b372aeb36367.png";